import React, { useState, useSelector } from 'react';
import PhoneInput2 from 'react-phone-input-2';
import { connect } from 'react-redux';
import { Col, FormGroup, Label, Button } from 'reactstrap';
import parsePhoneNumber from 'libphonenumber-js';
import { onSendFaxFilesChange, onSendFaxNumberChange } from '../actions/Fax';
import CustomDropzone from './CustomDropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import remove from '../Res/Icon/remove.png'

const initialNumber = '+1'
const duplicateErrorText = 'Oops! its duplicate entry';
const numberOfAllowedFilesForFax = 5
const numberOfAllowedReceiversForFax = 10

const SendFaxForm = (props) => {
  const [error, setError] = useState('')
  const [hideUploadFile, setHideUploadFile] = useState(false)
  const faxNumbers = props.faxNumbers

  const onAddFaxNumber = () => {
    setError('');
    if (faxNumbers.length < numberOfAllowedReceiversForFax) {
      const phoneNumber = parsePhoneNumber(currentValue, 'US');
    if (phoneNumber && phoneNumber.isValid() === true) {
      const find = !faxNumbers.includes(currentValue)
      find && props.onAddFaxNumber([...faxNumbers, currentValue]);
      if (!find) {
        setError(duplicateErrorText)
      }
      find && setCurrentValue(initialNumber)
    } else {
      setError('Invalid Entry')
    }
    }
  }

  const onFileChange = (file) => {

    if (file.length > numberOfAllowedFilesForFax) {
      setError(`Only ${numberOfAllowedFilesForFax} attachments are allowed`); // in case of multi-select
      setTimeout(() => {
        setError('')
      }, 3500)
      return
    }
    const filesNameList = []
    const filteredFiles = []
    for (let index = 0; index < file.length; index++) {
      const element = file[index];
      if (filesNameList.includes(element.name)) {
        setError(duplicateErrorText);
        setTimeout(() => {
          setError('')
        }, 3500)
      } else {
        filesNameList.push(element.name);
        filteredFiles.push(element)
      }
    }
    const newArray = filteredFiles ? [...filteredFiles] : []
    props.onFileChange(newArray);

    if (newArray.length >= numberOfAllowedFilesForFax) {
      setHideUploadFile(true)
    } else {
      !hideUploadFile && setHideUploadFile(false) // in case of file removal 
    }
  }

  const onRemoveNumber = (number) => {
    const filteredNumber = faxNumbers.filter(val => val != number);
    props.onAddFaxNumber([...filteredNumber])
  }
  const [currentValue, setCurrentValue] = useState(initialNumber)

  return (
    <div className="container">
      {error && <p className='error-text text-center '>{error}</p>}
      <div className="row">
        <Col sm={12}>
          <FormGroup row>
            <Label for="number" sm={4}>
              Receiver:
            </Label>
            <Col sm={12} md={9} className="d-flex align-items-center">
              <span className='flex-grow-1'>
                <PhoneInput2
                  inputExtraProps={{ name: 'number' }}
                  value={currentValue}
                  onChange={(val) => {
                    console.log({ val })
                    setCurrentValue(val)
                    setError('')
                  }}
                  onEnterKeyPress={onAddFaxNumber}
                  disabled={faxNumbers.length == numberOfAllowedReceiversForFax}
                />
                <div className='multi-input-info'>Type a value and press <b>enter</b> to add to the list</div>
              </span>
              <span className="multi-input-control-indicator ml-1 mt-1" style={{ height: '34px', position: 'relative' }}>
                {currentValue.length > 2 && (
                  <Button
                    style={{ background: '#3b5aa9', border: 'none', color: '#FFFFFF' }}
                    onClick={onAddFaxNumber}
                  >
                    <FontAwesomeIcon
                      icon="plus"
                      size="sm"
                      color="#FFFFFF"
                      style={{ marginRight: '1rem' }}
                    />
                    Add
                  </Button>
                )}
              </span>
            </Col>
          </FormGroup>
          {(faxNumbers || []).map((number) => (
            <div className="multi-input-item" key={number}>
              <span className="item">{number}</span>
              <img
                className="remove-icon ml-1"
                src={remove}
                onClick={() => onRemoveNumber(number)}
                alt="remove"
              />
            </div>
          ))}
          <FormGroup row>
            <Label for="faxFile" sm={8}>
              Upload Fax:
            </Label>
            <Col sm={12} md={12}>
              <CustomDropzone
                onFileChange={onFileChange}
                files={props.files}
                allowOnce={false}
                show={!hideUploadFile}
              />
            </Col>
          </FormGroup>
        </Col>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  faxNumbers: state.UIState.faxes.sendFax.numbers,
  files: state.UIState.faxes.sendFax.files,
});

const mapDispatchToProps = dispatch => ({
  onAddFaxNumber: number => dispatch(onSendFaxNumberChange(number)),
  onFileChange: files => dispatch(onSendFaxFilesChange(files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SendFaxForm);